import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";
import {SET_PAGINATE} from "./paginate.module";

// action types
export const GET_FILES = "getFiles";
export const DELETE_FILE = "deleteFile";

// mutation types
export const SET_FILES = "setFiles";
export const SET_FILES_ERROR = "setFilesErrors";
export const SET_FILE_LOAD = "setFilesLoad";

const state = {
    errors: {},
    files: [],
    load: true,
    paginate: {
        current_page: '',
        from: '',
        last_page: '',
        last_page_url: '',
        next_page_url: '',
        per_page: '',
        prev_page_url: '',
        to: '',
        total: '',
    }
};

const getters = {

    gettersFiles(state) {
        return state.files;
    },

    paginateFiles() {
        return state.paginate;
    },

    getFilesLoad(){
        return state.load;
    },

    errorsFiles(){
        return state.errors;
    },
};

const actions = {

    [GET_FILES](context, data) {
        context.commit(SET_FILE_LOAD, true);
        return new Promise((resolve, reject) => {
            ApiService.post("/files", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_FILES, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_FILE_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_FILES_ERROR, response.data.errors);
                    context.commit(SET_FILE_LOAD, false);
                });
        });
    },

    [DELETE_FILE](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/file/delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_FILES_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },


};

const mutations = {

    [SET_FILES](state, data) {
        state.files = data.data;

        state.paginate.current_page = data.current_page;
        state.paginate.from = data.from;
        state.paginate.last_page = data.last_page;
        state.paginate.last_page_url = data.last_page_url;
        state.paginate.next_page_url = data.next_page_url;
        state.paginate.per_page = data.per_page;
        state.paginate.prev_page_url = data.prev_page_url;
        state.paginate.to = data.to;
        state.paginate.total = data.total;
    },

    [SET_FILES_ERROR](state, error) {
        state.errors = error;
    },

    [SET_FILE_LOAD](state, load) {
        state.load = load;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};